import { requestFromServer } from './api-client';

const NotificationClient = {
	getNotificationsByBranchRegions: async (branchRegionNumbers = '', skipNumber = 0) => {
		// let branchRegions = branchRegionNumbers.replaceAll(',', '/');

		// return requestFromServer(
		// 	`v1/Notifications/getByBranchRegionAndLoggedUser/${skipNumber}${branchRegionNumbers ? `/${branchRegions}` : ''}`
		// );
	},
	getNotifications: async (branchNumbers = '', skipNumber = 0) => {
		// let branches = branchNumbers.replaceAll(',', '/');
		// return requestFromServer(
		// 	`v1/Notifications/getByLoggedUser/${skipNumber}${branchNumbers ? `/${branches}` : ''}`
		// );
	},
	setReadNotification: async (idNotification) => {
		// return requestFromServer(`v1/Notifications/setAsRead/${idNotification}`, 'PUT');
	},
	postSubscriptionToNotifications: async (subscription) => {
		// const _body = {
		// 	subscription_metadata: subscription
		// };
		// return requestFromServer('v1/Notifications/subscrib', 'POST', _body);
  },
  getSchedulingConfig: async () => {
    return requestFromServer('v1/Notifications/getSchedulingConfig', 'GET');
  },
  setSchedulingConfigAsRead: async (notification) => {
    const body = notification;
    return requestFromServer(`v1/Notifications/setSchedulingConfigAsRead`, 'PUT', body);
  }
};


export default NotificationClient;
